import React, {useContext, useState} from 'react';
import './header.css';
import {AppstoreOutlined, HomeOutlined} from '@ant-design/icons';
import {Menu} from 'antd';
import {useHistory} from "react-router-dom";
import {dataContext} from "../../../context";

function AppHeader() {
    let history = useHistory();
    const {setIsAdminPanelOpen} = useContext(dataContext);

    const [current, setCurrent] = useState("kampanyalar")

    function handleClick(e) {
        if (e.key === '/') {
            setIsAdminPanelOpen(false)
        }
        setCurrent("e.key", history.push(e.key));
    }

    return (
        <div className="app-title">
            <Menu  onClick={handleClick}
                  className="app-menu"
                  mode="horizontal"
                  style={{width: "100vw",marginRight: '-250px'}}
                  defaultSelectedKeys={['/kampanyalarıDüzenle']}
            >

                <Menu.Item key="/">
                    <HomeOutlined style={{color: 'volcano'}} className="nav-icon"/>
                </Menu.Item>

                {/*<Menu.SubMenu key="SubMenu" title="Kampanyalar"*/}
                {/*              icon={<AppstoreOutlined style={{color: '#eb2f96'}} className="nav-icon"/>}>*/}
                {/*    <Menu.Item key="/kampanyalarıDüzenle">*/}
                {/*        <AppstoreOutlined style={{color: '#eb2f96'}} className="nav-icon"/>*/}
                {/*        Kampayaları Düzenle*/}
                {/*    </Menu.Item>*/}
                {/*    <Menu.Item key="/anaSayfaKampanyaFotografı">*/}
                {/*        <AppstoreOutlined style={{color: '#eb2f96'}} className="nav-icon"/>*/}
                {/*        Ana Sayfa Kampanya Düzenle*/}
                {/*    </Menu.Item>*/}
                {/*</Menu.SubMenu>*/}

                <Menu.SubMenu key="SubMenus" title="Yakıt İşlemleri"
                    icon={<AppstoreOutlined style={{ color: '#BA68C8' }} className="nav-icon" />}>
                <Menu.Item key="/user">
                        <AppstoreOutlined style={{ color: '#F06292' }} className="nav-icon" />
                        Başvurular
                </Menu.Item>
                <Menu.Item key="/userList">
                        <AppstoreOutlined style={{ color: '#F06292' }} className="nav-icon" />
                         Faturalandırma
                </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu key="SubMenux" title="Tum Kullanicilar"
                     icon={<AppstoreOutlined style={{ color: '#4FC3F7' }} className="nav-icon" />}>
                <Menu.Item key="/eczacı-kart-kullanicilar">
                      <AppstoreOutlined style={{ color: '#26C6DA' }} className="nav-icon" />
                      Tum Kullanici Bilgileri
                </Menu.Item>

                </Menu.SubMenu>

                <Menu.Item key="/eczacı-kart">
                    <AppstoreOutlined style={{ color: '#08c' }} className="nav-icon" />
                    Eczacı Kart
                </Menu.Item>

            </Menu>
        </div>
    );
}

export default AppHeader;


// WEBPACK FOOTER //
// ./src/component/admin/header/header.js